import { useState } from "react";
import { Button } from "@/components/button";
import { Dialog } from "@/components/dialog";
import { Field, TextInput } from "@/components/fields";
import { useReportError } from "@/components/states";
import { useCreateWorkspace } from "./hooks";

export function NewWorkspaceDialog({ open, onClose, onCreated }: {
  open: boolean;
  onClose: () => void;
  onCreated: (wsid: string) => void;
}) {
  const create = useCreateWorkspace();
  const reportError = useReportError();
  const [name, setName] = useState("");

  function close() {
    setName("");
    onClose();
  }

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    try {
      onCreated((await create.mutateAsync(name)).wsid);
      close();
    } catch (err) {
      reportError(err);
    }
  }

  return (
    <form onSubmit={submit}>
      <Dialog
        open={open}
        onClose={close}
        title="New workspace"
        description="You become its first admin. Products pick it up the first time someone uses it."
        footer={
          <>
            <Button onClick={close}>Cancel</Button>
            <Button type="submit" tone="primary" disabled={create.isPending}>Create workspace</Button>
          </>
        }
      >
        <Field label="Name">
          <TextInput value={name} onChange={(e) => setName(e.target.value)} required maxLength={200}
            placeholder="Agentic AI" autoFocus />
        </Field>
      </Dialog>
    </form>
  );
}
